var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-message",class:{ owner: _vm.owner }},[_c('p',{staticClass:"message-body"},[_vm._v("\n    "+_vm._s(_vm.message.isi_chat)+"\n  ")]),_c('small',{staticClass:"d-block text-muted"},[_vm._v("\n    "+_vm._s(_vm.formatDateString(_vm.message.createdAt, true))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }